// ----------------------------------------------------------------------

export default function Tooltip(theme) {
  return {
    MuiTooltip: {
      defaultProps: {
        // Tooltips mount and unmount their portal on every hover. A page translator
        // (Chrome auto-translate & co.) rewrites the text nodes inside that portal, which
        // leaves React removing nodes their new parent no longer owns —
        // "NotFoundError: Failed to execute 'removeChild' on 'Node'". Excluding the popper
        // from translation keeps the DOM React's to manage. See also Overlay.js.
        slotProps: { popper: { translate: "no" } },
      },
      styleOverrides: {
        tooltip: {
          backgroundColor: theme.palette.grey[800],
        },
        arrow: {
          color: theme.palette.grey[800],
        },
      },
    },
  };
}
